import { Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Trainers from "../../../assets/images/Trainers.png";
import EnrolledStudents from "../../../assets/images/EnrolledStudents.png";
import Courses from "../../../assets/images/Courses.png";
import OngoingBatches from "../../../assets/images/OngoingBatches.png";
import Header from "../../../components/header/Header";
import Tile from "../../../components/tile/tile";
import Stats from "../../../components/stats/Stats";
import { CalendarBox } from "../../../components/calendar/CalendarBox";
import "./styles.css";
import axiosInstance from "../../../axios";
import { useLocation, useNavigate } from "react-router-dom";
import RouteContext from "../../../utils/context/RouteContext";

export const Dashboard = () => {
  const [DataDashboard, setDataDashboard] = useState();
  const [event, setEvent] = useState("all");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchDashboardData = await axiosInstance(
          `/dashboard?filterBy=${event}`
        );
        setDataDashboard(fetchDashboardData?.data?.payload);
      } catch (error) {
        console.log("Dashboard//error", error);
      }
    };
    fetchData();
  }, [event]);

  const { allowedRoutes, setAllowedRoutes, role, accessibleModules } =
    useContext(RouteContext);

  return (
    <>
      <div className="content-container">
        <Header title="Dashboard" />
        <Grid container spacing={4} sx={{ padding: "1rem" }}>
          <Grid item xs={8} sx={{ marginTop: 0, paddingTop: 0 }}>
            <Grid container spacing={4} sx={{ padding: "0 0rem 1rem 1rem" }}>
              <Grid item xs={6}>
                <Tile
                  image={EnrolledStudents}
                  text="Enrolled Students"
                  number={DataDashboard?.enrollmentStudents}
                  to="/courses/enrolled-students"
                />
              </Grid>
              <Grid item xs={6}>
                <Tile
                  image={Trainers}
                  to="/user/trainers"
                  text="Trainers"
                  number={DataDashboard?.trainers}
                />
              </Grid>
            </Grid>
            <Grid container spacing={4} sx={{ padding: "0 0rem 0rem 1rem" }}>
              <Grid item xs={6}>
                <Tile
                  image={Courses}
                  text="Courses"
                  number={DataDashboard?.activeCourses}
                  to="/courses"
                />
              </Grid>
              <Grid item xs={6}>
                <Tile
                  image={OngoingBatches}
                  text="Ongoing Batches"
                  number={DataDashboard?.batches?.ongoing}
                  to="/batch"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ padding: 0 }} xs={4}>
            <Stats DataDashboard={DataDashboard} />
          </Grid>
          <Grid item xs={12}>
            <CalendarBox DataDashboard={DataDashboard} setEvent={setEvent} />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
